import { useState } from 'react';

interface AddressCardProps {
  address: {
    id: string;
    label: string;
    url: string;
    status: string;
    speed: string;
    updatedAt: string;
    description: string;
  };
}

export default function AddressCard({ address }: AddressCardProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(address.url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-200 transition-all group">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-100">
            <i className="ri-link text-primary-600 text-sm"></i>
          </div>
          <h3 className="font-heading font-semibold text-foreground-950 text-sm">
            {address.label}
          </h3>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full whitespace-nowrap">
            正常
          </span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">
            {address.speed}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-2 bg-background-100 rounded-md px-3 py-2 mb-3">
        <span className="text-xs text-foreground-600 flex-1 truncate">
          {address.url}
        </span>
        <button
          onClick={handleCopy}
          className="flex-shrink-0 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer"
          title="复制地址"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className={copied ? 'ri-check-line text-primary-500 text-xs' : 'ri-file-copy-line text-xs'}></i>
          </div>
        </button>
      </div>
      <p className="text-xs text-foreground-500 leading-relaxed mb-2">
        {address.description}
      </p>
      <p className="text-xs text-foreground-400">
        更新于 {address.updatedAt}
      </p>
    </div>
  );
}